/**
 * Inline TTS markup: `{display|spoken}` — shows `display` on screen, but
 * sends `spoken` to the TTS engine instead. A pause is just the case where
 * `display` is empty: `Scherm geopend.{| ...} Klik verder.` shows "Scherm
 * geopend. Klik verder." but is spoken as "Scherm geopend. ... Klik verder."
 *
 * No new database field: this is one field, parsed two ways depending on
 * purpose. OpenAI's TTS has no SSML — punctuation (a longer "..." pause) and
 * literal phonetic respelling are the only real levers, so that's what the
 * `spoken` side is for.
 */
const MARKUP_RE = /\{([^{|}]*)\|([^{}]*)\}/g;

function collapseWhitespace(s: string): string {
  return s.replace(/[ \t]{2,}/g, ' ').trim();
}

export function extractDisplayText(raw: string): string {
  return collapseWhitespace(raw.replace(MARKUP_RE, (_m, display: string) => display));
}

export function extractSpokenText(raw: string): string {
  return collapseWhitespace(raw.replace(MARKUP_RE, (_m, _display: string, spoken: string) => spoken));
}
